import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Avatar,
  Box,
  CircularProgress,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';

import toNiceTimestamp from '../../../util/toNiceTimestamp';
import {
  approveBillingLink,
  rejectBillingLinkRequest,
  removeBillingLink,
} from '../../../actions/user';

const ConsolidatedBillingUser = ({ user, pending }) => {
  const dispatch = useDispatch();
  const [approveSubmitting, setApproveSubmitting] = useState(false);
  const [rejectSubmitting, setRejectSubmitting] = useState(false);
  const [removeSubmitting, setRemoveSubmitting] = useState(false);

  const handleApprove = async () => {
    setApproveSubmitting(true);
    await dispatch(approveBillingLink(user.customer_uuid));
    setApproveSubmitting(false);
  };

  const handleReject = async () => {
    setRejectSubmitting(true);
    await dispatch(rejectBillingLinkRequest(user.customer_uuid));
    setRejectSubmitting(false);
  };

  const handleRemove = async () => {
    setRemoveSubmitting(true);
    await dispatch(removeBillingLink(user.customer_uuid));
    setRemoveSubmitting(false);
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Avatar src={user.picture} sx={{ width: 40, height: 40, mr: 2 }} />
          <Box>
            <Typography variant='h6'>{user.display_name}</Typography>
            <Typography color='textSecondary'>{user.email}</Typography>
          </Box>
        </Box>
        <Typography variant='body2' color='textSecondary'>
          {pending
            ? `Requested on ${toNiceTimestamp(user.date)}`
            : `Linked since ${toNiceTimestamp(user.approved_date)}`}
        </Typography>
      </CardContent>
      <CardActions>
        {pending ? (
          <>
            <Button
              variant='outlined'
              color='success'
              onClick={handleApprove}
              disabled={approveSubmitting || rejectSubmitting}
              startIcon={
                approveSubmitting ? (
                  <CircularProgress size={20} />
                ) : (
                  <CheckIcon />
                )
              }
              fullWidth
            >
              {approveSubmitting ? 'Approving...' : 'Approve'}
            </Button>
            <Button
              variant='outlined'
              color='error'
              onClick={handleReject}
              disabled={approveSubmitting || rejectSubmitting}
              startIcon={
                rejectSubmitting ? (
                  <CircularProgress size={20} />
                ) : (
                  <CloseIcon />
                )
              }
              fullWidth
            >
              {rejectSubmitting ? 'Declining...' : 'Decline'}
            </Button>
          </>
        ) : (
          <Button
            variant='outlined'
            color='error'
            onClick={handleRemove}
            disabled={removeSubmitting}
            startIcon={
              removeSubmitting ? <CircularProgress size={20} /> : <DeleteIcon />
            }
            fullWidth
          >
            {removeSubmitting ? 'Removing...' : 'Remove'}
          </Button>
        )}
      </CardActions>
    </Card>
  );
};

export default ConsolidatedBillingUser;
